import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BranchesOutlinedSvg from "@ant-design/icons-svg/es/asn/BranchesOutlined";
import AntdIcon from '../components/AntdIcon';
var BranchesOutlined = function BranchesOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: BranchesOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(BranchesOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'BranchesOutlined';
}
export default RefIcon;